"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapUtils = void 0;
var proj_1 = require("ol/proj");
var coordinate_1 = require("ol/coordinate");
var MapUtils = /** @class */ (function () {
    function MapUtils() {
    }
    MapUtils.prototype.transformCoordinate = function (data) {
        /* S-JTSK (EPSG: 5514): v metroch na 3 desatinné miesta
        - WGS84 (EPSG: 4326): stupňe - minúty - sekundy
        - ETRS89 (EPSG: 3035): v metroch na 3 desatinné miesta*/
        var coordinate = data.coordinate;
        var fromEpsg = data.fromEpsg;
        var toEpsg = data.toEpsg;
        var result = {};
        if (coordinate && fromEpsg && toEpsg) {
            switch (fromEpsg) {
                case "4326":
                case "4258":
                    coordinate = [coordinate[1], coordinate[0]];
                    break;
            }
            var outCoord = (0, proj_1.transform)(coordinate, "EPSG:" + fromEpsg, "EPSG:" + toEpsg);
            var formatted = void 0;
            switch (toEpsg) {
                case "4326":
                case "4258":
                    formatted = {
                        outputValue: [parseFloat(outCoord[1].toFixed(5)), parseFloat(outCoord[0].toFixed(5))],
                        formatted: (0, coordinate_1.toStringHDMS)(outCoord)
                    };
                    break;
                default:
                    formatted = { outputValue: [parseFloat(outCoord[0].toFixed(3)), parseFloat(outCoord[1].toFixed(3))] };
            }
            result.success = true;
            result.coordinate = formatted;
        }
        else {
            result.success = false;
            result.error = 'Missing input';
        }
        return result;
    };
    return MapUtils;
}());
exports.MapUtils = MapUtils;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwVXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJNYXBVdGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxnQ0FBa0M7QUFDbEMsNENBQTJDO0FBRzNDO0lBQUE7SUF3Q0EsQ0FBQztJQXZDVSxzQ0FBbUIsR0FBMUIsVUFBMkIsSUFBcUU7UUFDNUY7O2dFQUV3RDtRQUN4RCxJQUFJLFVBQVUsR0FBRyxJQUFJLENBQUMsVUFBVSxDQUFDO1FBQ2pDLElBQU0sUUFBUSxHQUFHLElBQUksQ0FBQyxRQUFRLENBQUM7UUFDL0IsSUFBTSxNQUFNLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUMzQixJQUFJLE1BQU0sR0FBRyxFQUErQixDQUFDO1FBRTdDLElBQUksVUFBVSxJQUFJLFFBQVEsSUFBSSxNQUFNLEVBQUU7WUFDbEMsUUFBUSxRQUFRLEVBQUU7Z0JBQ2QsS0FBSyxNQUFNLENBQUM7Z0JBQ1osS0FBSyxNQUFNO29CQUNQLFVBQVUsR0FBRyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRSxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztvQkFDNUMsTUFBTTthQUNiO1lBQ0QsSUFBSSxRQUFRLEdBQUcsSUFBQSxnQkFBUyxFQUFDLFVBQVUsRUFBRSxPQUFPLEdBQUcsUUFBUSxFQUFFLE9BQU8sR0FBRyxNQUFNLENBQUMsQ0FBQztZQUUzRSxJQUFJLFNBQVMsU0FBQSxDQUFDO1lBQ2QsUUFBUSxNQUFNLEVBQUU7Z0JBQ1osS0FBSyxNQUFNLENBQUM7Z0JBQ1osS0FBSyxNQUFNO29CQUNQLFNBQVMsR0FBRzt3QkFDUixXQUFXLEVBQUUsQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUFFLFVBQVUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7d0JBQ3JGLFNBQVMsRUFBRSxJQUFBLHlCQUFZLEVBQUMsUUFBUSxDQUFDO3FCQUNwQyxDQUFDO29CQUNGLE1BQU07Z0JBQ1Y7b0JBQ0ksU0FBUyxHQUFHLEVBQUMsV0FBVyxFQUFFLENBQUMsVUFBVSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxVQUFVLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUMsQ0FBQzthQUUzRztZQUNELE1BQU0sQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDO1lBQ3RCLE1BQU0sQ0FBQyxVQUFVLEdBQUcsU0FBUyxDQUFDO1NBQ2pDO2FBQU07WUFDSCxNQUFNLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQztZQUN2QixNQUFNLENBQUMsS0FBSyxHQUFHLGVBQWUsQ0FBQztTQUNsQztRQUNELE9BQU8sTUFBTSxDQUFDO0lBQ2xCLENBQUM7SUFDTCxlQUFDO0FBQUQsQ0FBQyxBQXhDRCxJQXdDQztBQXhDWSw0QkFBUSJ9